export function filterFilesByType(apiData, fileList, targetFileType) {
  // 1. Find all IDs in apiData that match the target file_type
  const matchingIds = new Set(
    apiData
      .filter(item => item.file_type === targetFileType)
      .map(item => item.file_id)
  );

  // 2. Filter the incoming file_list to keep only those IDs
  return fileList.filter(fileId => matchingIds.has(fileId));
};

export const dataTableStyles = {
  headRow: {
    style: {
      backgroundColor: "#2F9E37",
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
      minHeight: "48px",
    },
  },
  headCells: {
    style: {
      color: "white",
      fontSize: "12px",
      fontWeight: 600,
    },
  },
  cells: {
    style: {
      fontSize: "12px",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
};

export const testNumericVal = (value) => {
  if (value == null) return null;
  const parsed = Number(String(value).replace(/,/g, "").trim());
  return Number.isFinite(parsed) ? parsed : null;
};

export const testNumericCol = (rows, selector, sampleSize = 30) => {
  let seen = 0;
  let numeric = 0;

  for (let i = 0; i < rows.length && seen < sampleSize; i++) {
    const value = selector(rows[i]);
    if (value == null || String(value).trim() === "") continue;
    seen += 1;
    if (testNumericVal(value) !== null) numeric += 1;
  }

  return seen > 0 && numeric / seen > 0.8;
};

export const customColumnSort = (rows, selector, direction) => {
  const dir = direction === "desc" ? -1 : 1;
  const numericCol = testNumericCol(rows, selector);
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

  return [...rows].sort((a, b) => {
    const av = selector(a);
    const bv = selector(b);

    const aBlank = av == null || String(av).trim() === "";
    const bBlank = bv == null || String(bv).trim() === "";
    if (aBlank && bBlank) return 0;
    if (aBlank) return 1;
    if (bBlank) return -1;

    if (numericCol) {
      const an = testNumericVal(av);
      const bn = testNumericVal(bv);
      if (an === null && bn === null) return 0;
      if (an === null) return 1;
      if (bn === null) return -1;
      return (an - bn) * dir;
    }

    return collator.compare(String(av), String(bv)) * dir;
  });
};